import React from 'react';
export const TrustBar = () => {
  const logos = ['VOGUE BEAUTY', 'COSMOPOLITAN', 'GLAMOUR', 'BEAUTY PRO'];
  return <section className="py-10 border-y border-pink-medium bg-white/50 backdrop-blur-sm" data-id="element-305">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-306">
        <p className="text-center text-sm font-semibold tracking-widest text-text-muted mb-6 uppercase" data-id="element-307">
          Destacado en
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-308">
          {logos.map((logo, index) => <div key={index} className="font-serif text-xl md:text-2xl font-bold text-gold-dark tracking-wider" data-id="element-309">
              {logo}
            </div>)}
        </div>
      </div>
    </section>;
};